import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CareLineLayout from '../components/careline/CareLineLayout';
import CareLineFAQHero from '../components/careline/CareLineFAQHero';
import CareLineFAQSection from '../components/careline/CareLineFAQSection';
import { clinicService } from '../services/api';

const CareLineFAQ = () => {
    const { slug } = useParams();
    const [clinic, setClinic] = useState(null);

    useEffect(() => {
        if (!slug) return;
        clinicService.getBySlug(slug).then((res) => {
            if (res.data?.success) setClinic(res.data.data);
        }).catch(() => {});
    }, [slug]);

    return (
        <CareLineLayout
            activePage="faq"
            slug={slug}
            logo={clinic?.logo_url}
            clinicName={clinic?.nama_klinik}
            primaryColor={clinic?.primary_color}
        >
            <main>
                <CareLineFAQHero
                    slug={slug}
                    primaryColor={clinic?.primary_color || '#06B6D4'}
                />
                <CareLineFAQSection />
            </main>
        </CareLineLayout>
    );
};

export default CareLineFAQ;
